import Ajax from '@utils/ajax';

export default {
  validateLink(url, options = {}) {
    return Ajax.post({
      url: `/embedded_posts/validate_link`,
      data: { url: url },
      ...options,
    });
  },

  create(group, url, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/embedded_posts`,
      data: { url: url },
      ...options,
    });
  },

  getPostById(group, postId, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/embedded_posts/${postId}`,
      ...options,
    });
  },
  getPosts(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/embedded_posts`,
      ...options,
    });
  },

  delete(group, postId, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/embedded_posts/${postId}`,
      data: {
        _method: 'DELETE',
      },
      ...options,
    });
  },
};
